export const getOrganizationSetupItems = ({
  organization = {},
  details = {},
  stripeConnected = false,
  administrators = [],
  documents = [],
}) => [
  {
    id: "details",
    label: "Identity & branding",
    description: "Name, contact details, domain, logo, and organization colors",
    complete: Boolean(details.name && details.contact_email && details.subdomain),
  },
  {
    id: "administrators",
    label: "Administrators & access",
    description: "Confirm who can manage programs, payments, people, and settings",
    complete: administrators.length > 0,
  },
  {
    id: "banking",
    label: "Payments & payouts",
    description: "Connect Stripe and verify that charges and payouts are ready",
    complete: Boolean(stripeConnected),
  },
  {
    id: "documents",
    label: "Registration documents",
    description: "Prepare waivers and documents used across registration flows",
    complete: documents.length > 0,
  },
  {
    id: "integrations",
    label: "Integrations",
    description: "Review connected services and the data they can access",
    complete: Boolean(stripeConnected || organization.squadline_enabled),
  },
  {
    id: "notifications",
    label: "Notification defaults",
    description: "Choose the operational events that notify organization admins",
    complete: Boolean(organization.notification_settings),
  },
];

export const getSetupProgress = (items = []) => {
  const complete = items.filter((item) => item.complete).length;
  return {
    complete,
    total: items.length,
    percent: items.length ? Math.round((complete / items.length) * 100) : 0,
  };
};
